import { Separator } from "../ui/separator";
import { Skeleton } from "../ui/skeleton";

export default function NotificationSkeleton() {
    return (
        <div className="p-4 flex flex-col gap-4">
            <div className="flex items-center gap-2">
                <Skeleton className="size-[40px] rounded-full" />
                <div className="flex flex-col gap-1">
                    <Skeleton className="h-3 w-[100px]" />
                    <Skeleton className="h-3 w-[100px]" />
                </div>
            </div>
            <Separator />
            <div className="flex flex-col gap-2 items-start">
                <Skeleton className="h-3 w-[400px]" />
                <Skeleton className="h-3 w-[300px]" />
                <Skeleton className="h-3 w-[300px]" />
            </div>
        </div>
    );
}
